export default __webpack_public_path__ + "static/media/no-mandate-icon.b4566a98.svg";